import { useLocation } from 'react-router-dom';
import { IoChevronBack, IoChevronForward } from 'react-icons/io5';
import i18next from 'i18next';
import { useNotifications } from '../../context/NotificationContextProvider';
import './NotificationBar.css';

const NotificationBar = () => {
  const { pathname } = useLocation();
  const ctx = useNotifications();

  if (!ctx || pathname === '/embed') return null;

  const { pinnedItems, activeIndex, next, prev, seatUpdate } = ctx;

  if (!seatUpdate && (!pinnedItems || pinnedItems.length === 0)) return null;

  if (seatUpdate) {
    const inner = (
      <>
        <span className="tag tag--hot notif-bar__badge">
          {i18next.t('成绩更新')}
        </span>
        <span className="notif-bar__title">{seatUpdate.message}</span>
      </>
    );
    return (
      <div className="notif-bar notif-bar--seat" role="status">
        {seatUpdate.href ? (
          <a
            className="notif-bar__link"
            href={seatUpdate.href}
            target="_blank"
            rel="noreferrer"
            aria-label={seatUpdate.message}
          >
            {inner}
          </a>
        ) : (
          <div className="notif-bar__link">{inner}</div>
        )}
      </div>
    );
  }

  const item = pinnedItems[Math.min(activeIndex, pinnedItems.length - 1)];
  const hasPaging = pinnedItems.length > 1;

  return (
    <div className="notif-bar" role="region" aria-label={i18next.t('置顶新闻')}>
      {hasPaging && (
        <button
          type="button"
          className="notif-bar__nav"
          onClick={prev}
          aria-label="Previous"
        >
          <IoChevronBack />
        </button>
      )}
      <a
        className="notif-bar__link"
        href={item.href + '?utm_source=election' || '#'}
        target="_blank"
        rel="noreferrer"
      >
        {item.image && (
          <img
            className="notif-bar__thumb"
            src={item.image}
            alt=""
            loading="lazy"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        )}
        <span className="tag tag--hot notif-bar__badge">
          {i18next.t('置顶新闻')}
        </span>
        <span className="notif-bar__title">{item.title}</span>
      </a>
      {hasPaging && (
        <button
          type="button"
          className="notif-bar__nav"
          onClick={next}
          aria-label="Next"
        >
          <IoChevronForward />
        </button>
      )}
    </div>
  );
};

export default NotificationBar;
